import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Drone Engineering Foundations & UAV Ecosystem",
    description:
      "What are drones? Types: quadcopter, hexacopter, fixed-wing, hybrid,UAV applications: delivery, surveillance, agriculture, mapping, defense, Drone subsystems: frame, propulsion, control, power, communication, Drone regulations (DGCA/FAA basics),Future of drone technology & global trends",
  },
  {
    title: "Aerodynamics, Flight Mechanics & Stability",
    description:
      "Basics of aerodynamics: lift, drag, thrust, weight, Propeller dynamics & thrust generation,Multirotor flight stability, Understanding pitch, roll, yaw & center of gravity, How drones maintain balance & orientation",
  },
  {
    title: "Mechanical Design, Frame Building & CAD Modeling",
    description:
      "Drone frame types, materials & weight optimization, Designing drone chassis using CAD tools (SolidWorks/Fusion 360), Vibration control & structural integrity, Integrating arms, mounts, landing gears, Hands-on: Assembling a drone airframe",
  },
  {
    title: "Electronics, Sensors & Flight Controller System",
    description:
      "ESCs, motors, power distribution boards, Flight controllers (Pixhawk, KK, Betaflight, Ardupilot), Inertial Measurement Unit (IMU): accelerometer, gyroscope, GPS, barometer, magnetometer, sonar & lidar, Wiring, calibration & sensor integration",
  },
  {
    title: "Battery Systems, Power Management & Safety",
    description:
      "Li-Po battery chemistry & ratings (C-rating, mAh, voltage), Charging, balancing & battery life enhancement, Power estimation for flight time, ESC & motor compatibility, Safety protocols to avoid battery hazards",
  },
  {
    title: "Remote Control, Radio Systems & Telemetry",
    description:
      "RC transmitters & receivers (2.4 GHz/5.8 GHz), Telemetry modules for real-time data, Understanding channels, modes & fail-safe, FPV camera systems & video transmission, Long-range communication techniques",
  },
  {
    title: "Autonomous Drones, GPS Navigation & Path Planning",
    description:
      "Introduction to autopilot systems, GPS-based navigation, Waypoint missions & mission planners, Obstacle detection & avoidance, Basics of SLAM (Simultaneous Localization & Mapping)",
  },
  {
    title: "Drone Programming, Control Algorithms & Onboard AI",
    description:
      "PID control & tuning, Arduino, Raspberry Pi, and STM32 for drones, Writing scripts for autonomous behaviors, Integrating computer vision with OpenCV, AI applications: object tracking, gesture control, target following",
  },
  {
    title: "Drone Testing, Troubleshooting & Maintenance",
    description:
      "Pre-flight checks & calibration, Motor, ESC & propeller diagnostics, Tuning flight characteristics, Crash analysis & repair techniques, Routine maintenance for long drone life",
  },
  {
    title: "Capstone Drone Engineering Project & Career Launchpad",
    description:
      "Build and fly a fully functional drone, Design → Assemble → Program → Test → Fly, Real-world project: surveillance drone, mapping drone, delivery drone, Drone portfolio creation with videos & flight logs, Resume building & interview prep for, Drone Engineer, UAV Pilot, Automation Engineer roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
